const routes = [
  {
    path: ["/", "/home","/homework-club-wjls"],
    exact: true,
    component: "Home",
  },
];

export default routes;
